import style from "./StepBar.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(style);

export default function StepBar(props: {
    title1: string;
    title2: string;
    selected: number;
    setSelected: (index: number) => void;
}) {
    return (
        <div className={style.container}>
            <div
                className={cx(style.button, {
                    selected: props.selected === 0,
                })}
                onClick={() => {
                    props.setSelected(0);
                }}
            >
                <div className={style.text}>{props.title1}</div>
            </div>
            <div className={style.icon} />
            <div
                className={cx(style.button, {
                    selected: props.selected === 1,
                })}
                onClick={() => {
                    props.setSelected(1);
                }}
            >
                <div className={style.text}>{props.title2}</div>
            </div>
        </div>
    );
}
